import React from "react";
import QuestionMark from "src/icons/QuestionMark";

export default function CountryFlag(props: {
  countrycode: string;
  size: number;
  isGuest?: boolean;
}) {
  const { size, countrycode, isGuest } = props;
  return (
    <div
      style={{
        width: size,
        height: size,
        position: "relative",
        overflow: "hidden",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "white",
      }}>
      {isGuest ? (
        <QuestionMark />
      ) : (
        <img
          style={{
            display: "inline",
            height: "100%",
            width: "auto",
            borderRadius: "50%",
            background: "white",
          }}
          src={`https://flagicons.lipis.dev/flags/4x3/${countrycode}.svg`}
          alt="..."
        />
      )}
    </div>
  );
}
